import { produce } from "immer";
import {
  FETCH_REVIEWS,
  FETCH_REVIEWS_SUCCESS,
  FETCH_REVIEWS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_REVIEWS,
  ADD_REVIEWS_SUCCESS,
  ADD_REVIEWS_FAILURE,
  //
  EDIT_REVIEWS,
  EDIT_REVIEWS_SUCCESS,
  EDIT_REVIEWS_FAILURE,
  //
  DELETE_REVIEWS,
  DELETE_REVIEWS_SUCCESS,
  DELETE_REVIEWS_FAILURE,
  //
  TOGGLE_MOD_MODAL,
  //
  FETCH_UPLOADS,
  FETCH_UPLOADS_SUCCESS,
  FETCH_UPLOADS_FAILURE,
  //
  ADD_REVIEW_CARD,
  ADD_REVIEW_CARD_SUCCESS,
  ADD_REVIEW_CARD_FAILURE,
  //
  EDIT_REVIEW_CARD,
  EDIT_REVIEW_CARD_SUCCESS,
  EDIT_REVIEW_CARD_FAILURE,
  //
  GET_CARD_DATA,
  GET_CARD_DATA_SUCCESS,
  GET_CARD_DATA_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingReviews: false,
  Reviews: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentReviews: {},
  // Delete
  isDeleting: false,
  //
  modModal: { open: false, review: {} },
  //
  isFetchingUploads: false,
  uploadList: [],
  //
  isUpdatingCard: false,
  isFetchingCard: false,
  currentCard: {},
};

const ReviewsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_REVIEWS:
        draft.isFetchingReviews = true;
        draft.currentReviews = {};
        break;
      case FETCH_REVIEWS_SUCCESS:
        draft.isFetchingReviews = false;
        draft.Reviews = action.payload;
        break;
      case FETCH_REVIEWS_FAILURE:
        draft.isFetchingReviews = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentReviews = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentReviews = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_REVIEWS:
        draft.isSubmitting = true;
        break;
      case ADD_REVIEWS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_REVIEWS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_REVIEWS:
        draft.isSubmitting = true;
        break;
      case EDIT_REVIEWS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_REVIEWS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_REVIEWS:
        draft.isDeleting = true;
        break;
      case DELETE_REVIEWS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_REVIEWS_FAILURE:
        draft.isDeleting = false;
        break;
      //
      case TOGGLE_MOD_MODAL:
        draft.modModal = action.payload;
        break;
      case FETCH_UPLOADS:
        draft.isFetchingUploads = true;
        draft.uploadList = [];
        break;
      case FETCH_UPLOADS_SUCCESS:
        draft.isFetchingUploads = false;
        draft.uploadList = action.payload;
        break;
      case FETCH_UPLOADS_FAILURE:
        draft.isFetchingUploads = false;
        draft.uploadList = [];
        break;

      case ADD_REVIEW_CARD:
        draft.isAddingCard = true;
        break;
      case ADD_REVIEW_CARD_SUCCESS:
        draft.isAddingCard = false;
        break;
      case ADD_REVIEW_CARD_FAILURE:
        draft.isAddingCard = false;
        break;

      case EDIT_REVIEW_CARD:
        draft.isUpdatingCard = true;
        break;
      case EDIT_REVIEW_CARD_SUCCESS:
        draft.isUpdatingCard = false;
        break;
      case EDIT_REVIEW_CARD_FAILURE:
        draft.isUpdatingCard = false;
        break;

      case GET_CARD_DATA:
        draft.isFetchingCard = true;
        draft.currentCard = {};
        break;
      case GET_CARD_DATA_SUCCESS:
        draft.isFetchingCard = false;
        draft.currentCard = action.payload;
        break;
      case GET_CARD_DATA_FAILURE:
        draft.isFetchingCard = false;
        draft.currentCard = {};

        break;

      default:
        return state;
    }
  });

export default ReviewsReducer;
